import { isNil } from 'lodash/fp';

//this function retruns -> entity is CustomEntity
export const isCustomEntity = (entity: any): boolean => {
    return !isNil(entity.creator);
};
